import { StyleSheet } from 'react-native';
import {
  fontFamilySemiBold,
  lightGrey,
  lightPurple,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginVertical: 18,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: lightGrey,
  },
  linkText: {
    textAlign: 'center',
    color: lightPurple,
    fontFamily: fontFamilySemiBold,
  },
});
